import * as React from 'react';

import classNames from 'classnames';

import { getTranslation } from '@base/utils';

import { ErrorScreen } from '@components';

import { ButtonDefault } from '@ui';

import * as s from './ErrorOfflineScreen.scss';

export interface IErrorOfflineScreenProps {
	className?: string;
}

export const ErrorOfflineScreen = (props: IErrorOfflineScreenProps) => {
	const {
		className,
	} = props;
	const onButtonClick = () => {
		location.reload();
	};

	return <ErrorScreen className={classNames(s.block, className)}>
		{getTranslation('components.ErrorOfflineScreen')('offline')}
		<ButtonDefault className={s.button} onClick={onButtonClick}>
			{getTranslation('components.ErrorOfflineScreen')('refresh')}
		</ButtonDefault>
	</ErrorScreen>;
};
